<template>
    <section id="footer-cta" class="py-5 bg-darkgrey txt-white">
		<div class="container">
			<div class="row justify-content-center mb-5">
				<div class="col-lg-8">
					<h2 class="text-center uc">Solve your financial emergency quickly using our <span class="grad-text">easy to use</span> form</h2>
				</div><!--End Col 8-->
			</div><!--End Row-->
			<div class="call-to-action text-center">
				<HomeLeadFormButton />
			</div>
		</div><!--End Container-->
	</section>
</template>

<script>
import HomeLeadFormButton from '@/components/home/HomeLeadFormButton.vue';

export default {
    name: 'FooterCTA',
    components: {
        HomeLeadFormButton
    }
}
</script>

<style>

</style>
